module.exports = __webpack_public_path__ + "img/image_cell.041e1b6a.svg";